/**
 * Preserve the legacy call contract without sending obsolete ActionLog traffic.
 * Call sites and their historical tests can be removed in a dedicated cleanup.
 * @type {(event: unknown) => Promise<null>}
 */
const logEvent = () => Promise.resolve(null);

export default logEvent;
